import React, { FC, useCallback, useState } from "react";
import _ from "lodash";

import Page from "../common/navigation/Page";
import FormFields from "../common/form/FieldsList";
import FormButtons from "../common/form/Buttons";
import F7 from "../../utils/F7";
import { useNavigate } from "react-router-dom";
import { Field } from "../common/form/FieldHandler";
import Spinner from "../common/F7/Spinner";
import { useUpdateProject } from "../../hooks/database/usePouchUpdate";
import * as uuid from "uuid";
import { useCurrentProject } from "../../hooks/database/useCurrentProject";

const InventoryCreatePage: FC = () => {
  const navigate = useNavigate();

  const { data: project } = useCurrentProject();
  const { execute: updateProject } = useUpdateProject();

  const [form, setForm] = useState<Record<"name" | "cluster", Field>>({
    name: {
      label: "Inventory Name",
      type: "text",
      value: null,
      required: true,
    } as Field,
    cluster: {
      label: "Cluster Points",
      type: "checkbox",
      value: false,
    } as Field,
  });

  const handleSave = useCallback(async () => {
    const name = form.name.value as string;
    const cluster = form.cluster.value as boolean;

    if (!name || name.length < 1) {
      F7.alert("", "Inventory Name is required");
      return;
    } else if (name.length > 0 && name.charCodeAt(0) === 32) {
      F7.alert("", "Inventory Name can not start with a blankspace");
      return;
    }

    const id = "inventory-" + uuid.v4();
    await updateProject(_.merge(project!, { inventories: { [id]: { name, cluster, forms: {}, styles: {}, labelField: null } } }));
    navigate(`../`);
  }, [form.name.value, form.cluster.value, updateProject, project, navigate]);

  const handleCancel = useCallback(() => {
    navigate("../");
  }, [navigate]);

  const handleFormChange = useCallback((field: string, value: Field["value"]) => {
    setForm((f) => _.merge({}, f, { [field]: { value } }));
  }, []);

  if (!project) {
    return <Spinner />;
  }

  return (
    <Page title="Create new inventory" noToolbar>
      <FormFields fields={form} onChange={handleFormChange} />

      <FormButtons onSave={handleSave} onCancel={handleCancel} />
    </Page>
  );
};

export default InventoryCreatePage;
